"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class FormClient extends authenticated_client_1.AuthenticatedClient {
    findById(projectId, id, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms/${id}`;
            const response = yield this.httpGet(url + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    findFormBySnapshotId(projectId, snapshotId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/forms`;
            const response = yield this.httpGet(url + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    createForm(projectId, formCreateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms`;
            const response = yield this.httpPost(url, formCreateRequest);
            return response.payload;
        });
    }
    updateForm(projectId, id, formUpdateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms/${id}`;
            const response = yield this.httpPut(url, formUpdateRequest);
            return response.payload;
        });
    }
    deleteForm(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms/${id}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    deleteFormBySnapshot(projectId, snapshotId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/forms`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
}
exports.FormClient = FormClient;
//# sourceMappingURL=form.client.js.map